/// <reference path='../../typings/browser.d.ts' />
/// <reference path='../../customtypings/angular-peity/angular-peity.d.ts' />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />

namespace Application.Directives {
    'use strict';

    import TrendingInfo = Models.TrendingInfo;
    import IPlotPoint = Models.IPlotPoint;
    import Digicon = Application.Models.Digicon;
    declare type GridDigiconMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                  $timeout: angular.ITimeoutService,
                                                  $location: ng.ILocationService,
                                                  streamStatusService: Services.StreamStatusService,
                                                  $q: ng.IQService,
                                                  alarmsService: Services.AlarmsService,
                                                  stompService: Services.StompService,
                                                  $cookies: ng.cookies.ICookiesService,
                                                  timezoneService: Services.TimezoneService,
                                                  flexCollectorService: Services.FlexCollectorService,
                                                  $rootScope: Services.IFlexSettings,
                                                  digiconService: Services.DigiconService,
                                                 ) => GridDigiconMonitorDirective;

    export interface IGridDigiconMonitorScopeDef {
        model: string;
        id: string;
        showTrending: string;

    }

    interface ICriticalAlarm {
        alarmName: string;
        deviceSimplifiedHref: string;
    }

    export interface IGridDigiconMonitorScope extends ng.IScope {
        model: Models.kitInfo;
        id: string;
        humanReadableBits: (bits: number) => string;

        plot: jquery.flot.plot;
        loadStreamData: () => void;
        initIntervals: () => void;
        getContentStyle: () => Object;
        monitorStatus: string;

        streamDataTimerPromise: angular.IPromise<void>;
        monitorInfoLabel: string;
        deviceIds: string[];
        paramNameOutput: string;
        paramNameInput: string;
        hasData: () => boolean;
        showHistoricalTraffic: () => void;
        trendingInfos: TrendingInfo[];
        plotOptions: Chart.ChartOptions;
        showTrending: boolean;
        reRender: boolean;
        stompReconnectUnsubscribe: Function;
        plotSeries: IPlotPoint[][];
        lastValidPoints: IPlotPoint[];
    }

    export class GridDigiconMonitorDirective implements ng.IDirective {
        public static $name: string = 'gridDigiconMonitor';
        public static $inject: string[] = [];

        private static maxGraphSeconds: number = 90;
        private static STREAM_DATA_TIMER: number = 4000;

        public link: (scope: IGridDigiconMonitorScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/grid-digicon-monitor-directive.html';
        public scope: IGridDigiconMonitorScopeDef = {
            model: '=',
            id: '=',
            showTrending: '=',
        };

        constructor(private $interval: angular.IIntervalService,
                    private $timeout: angular.ITimeoutService,
                    private $location: ng.ILocationService,
                    private streamStatusService: Services.StreamStatusService,
                    private $q: ng.IQService,
                    private alarmsService: Services.AlarmsService,
                    private stompService: Services.StompService,
                    private $cookies: ng.cookies.ICookiesService,
                    private timezoneService: Services.TimezoneService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private $rootScope: Services.IFlexSettings,
                    private digiconService: Services.DigiconService) {
            GridDigiconMonitorDirective.prototype.link = (scope: IGridDigiconMonitorScope, element: JQuery, attrs: ng.IAttributes) => {
                console.log("model: ", scope.model);
                scope.showTrending = true;
                scope.plotOptions = {
                    layout: {
                        padding: {
                            top: 10,
                            bottom: 10,
                        },
                    },
                    elements: {
                        line: {
                            borderWidth: 4,
                            fill: false,
                        },
                        point: {
                            radius: 0,
                        },
                    },
                };
                this.initData(scope).then(() => {
                    this.initBindings(scope);
                    this.getTrendingData(scope);
                });


                scope.humanReadableBits = (bits: number): string => {
                    // incoming data is megabits
                    if (bits !== undefined) {
                        return Common.Utils.kibiHumanReadableBits(bits);
                    } else {
                        return "No data";
                    }
                };

                scope.getContentStyle = (): Object => {
                    let container: JQuery = $('.grid-thumb-monitor-wrapper').parent();
                    let width: number = container.width();
                    let height: number = container.height();
                    let aR: number = 16 / 9;
                    let monitorWidth: number;
                    let monitorHeight: number;
                    let monitorTop: number = 0;
                    let monitorLeft: number = 0;
                    if (width / height > aR) {
                        monitorWidth = height * aR;
                        monitorHeight = height;
                        monitorLeft = (width - monitorWidth) / 2;
                    } else {
                        monitorWidth = width;
                        monitorHeight = width / aR;
                        monitorTop = (height - monitorHeight) / 2;
                    }
                    return {
                        'width': `${monitorWidth}px`,
                        'height': `${monitorHeight}px`,
                        'position': 'relative',
                        'top': `${monitorTop}px`,
                        'left': `${monitorLeft}px`,
                    };
                };

                scope.hasData = (): boolean => {
                    return scope.plotSeries && scope.plotSeries[0] !== undefined && scope.plotSeries.length > 0;
                };

                scope.showHistoricalTraffic = (): void => {
                    if (scope.model.sourceName || scope.model.sinkName) {
                        console.log(scope.model.sourceName);
                        const digiconId: string = scope.model.sourceName.split(":")[1].split("-")[0].trim();
                        scope.model.type = "Digicon";
                        let matchday =  scope.model.matchDay === "t" ? "tuesday" : "wednesday";
                        let title: string = scope.model.sourceName + " -  " + matchday + " - " + scope.model.matchNumber;
                        this.$location.path(`/historicalByDigicon/${scope.model.type}/${digiconId}/${title}/bitrate`);
                    }
                };
            };
        }

        public static Factory(): GridDigiconMonitorDirectiveCb {
            let directive: GridDigiconMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                            $timeout: angular.ITimeoutService,
                                                            $location: ng.ILocationService,
                                                            streamStatusService: Services.StreamStatusService,
                                                            $q: ng.IQService,
                                                            alarmsService: Services.AlarmsService,
                                                            stompService: Services.StompService,
                                                            $cookies: ng.cookies.ICookiesService,
                                                            timezoneService: Services.TimezoneService,
                                                            flexCollectorService: Services.FlexCollectorService,
                                                            $rootScope: Services.IFlexSettings,
                                                            digiconService: Services.DigiconService) => {
                return new GridDigiconMonitorDirective($interval,
                                                $timeout,
                                                $location,
                                                streamStatusService,
                                                $q,
                                                alarmsService,
                                                stompService,
                                                $cookies,
                                                timezoneService,
                                                flexCollectorService,
                                                $rootScope,
                                                digiconService);
            };
            directive.$inject = ['$interval',
                                 '$timeout',
                                 '$location',
                                 'streamStatusService',
                                 '$q',
                                 'alarmsService',
                                 'stompService',
                                 '$cookies',
                                 'timezoneService',
                                 'flexCollectorService',
                                 '$rootScope',
                                 'digiconService'
                                ];
            return directive;
        }

        private initData(scope: IGridDigiconMonitorScope): ng.IPromise<void> {

            scope.deviceIds = [];
            const promises: ng.IPromise<void>[] = [];
            scope.deviceIds.push('digicon/' + scope.model.mainKit.id);
            scope.model.sourceName = "Kit: " + scope.model.mainKit.id;
            scope.reRender = true;
            return this.$q.all(promises).then(() => {
                return;
            });
        }

        private initBindings(scope: IGridDigiconMonitorScope): void {
            scope.stompReconnectUnsubscribe = this.$rootScope.$on('stompReconnect', () => {
                if (scope.trendingInfos) {
                    scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                        trendingInfo.closeAfterReconection();
                        trendingInfo.initTrendingData();
                    });
                } else {
                    this.getTrendingData(scope);
                }
            });

            scope.$on('$destroy', () => {
                this.$interval.cancel(scope.streamDataTimerPromise);
                this.close(scope);
            });

            this.$interval.cancel(scope.streamDataTimerPromise);
            // fix to avoid too many flex collector requests
            let fakeDataCycle = 0;
            scope.streamDataTimerPromise = this.$interval(() => {
                if(fakeDataCycle > 0){
                    this.fakeData(scope);
                    fakeDataCycle = fakeDataCycle - 1;
                }else{
                    this.getTrendingData(scope);
                    fakeDataCycle = 10;
                }
            }, GridDigiconMonitorDirective.STREAM_DATA_TIMER + Common.Utils.randomNumber(600));


            scope.$watch('model', (newValue: Models.Monitor, oldValue: Models.Monitor) => {
                if (newValue !== oldValue) {
                    this.close(scope);
                    this.initData(scope).then(() => {
                        this.getTrendingData(scope, true);
                    });

                }
            });
            scope.$watch('showTrending', (newVal: boolean, oldVal: boolean) => {
                scope.showTrending = newVal;
                scope.reRender = false;
                setTimeout(() => scope.reRender = true, 0);
            });
        }

        private close(scope: Application.Directives.IGridDigiconMonitorScope): void {
            if (scope.trendingInfos) {
                scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                    trendingInfo.close();
                });
                scope.trendingInfos = undefined;
            }
            scope.stompReconnectUnsubscribe();
        }

        private getTrendingData(scope: IGridDigiconMonitorScope, forceRefresh: boolean = false): void {
            if (scope === undefined) {
                return;
            }

            if (!scope.trendingInfos) {
                scope.plotSeries = [];
                scope.lastValidPoints = [];
                // we create just one TrendingInfo (one deviceID) but with multiple bitrates
                scope.trendingInfos = scope.deviceIds.map((deviceId: string, index: number) => {
                    const trendingInfo: TrendingInfo = new TrendingInfo(
                        this.streamStatusService, this.flexCollectorService, this.$timeout,
                        this.$q,
                        deviceId, GridDigiconMonitorDirective.maxGraphSeconds, true,
                        () => {
                            this.updatePlotSeries(scope, index);
                         },
                        ["trunk_bitrate", "360_bitrate", "files_bitrate", "aperi_bitrate", "EN07_bitrate", "EN08_bitrate"],
                        60000
                    );
                    scope.plotSeries.push(undefined);
                    scope.plotSeries.push(undefined);
                    scope.plotSeries.push(undefined);
                    scope.plotSeries.push(undefined);
                    scope.plotSeries.push(undefined);
                    scope.plotSeries.push(undefined);
                    scope.lastValidPoints.push(undefined);
                    return trendingInfo;
                });
                scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                    trendingInfo.initTrendingData();
                });
            }
         }

         /**
          * function to send last params to the graph instead or requesting them to flex collector
          * @param scope 
          */
        private fakeData(scope: IGridDigiconMonitorScope){
            scope.deviceIds.map((deviceId: string, index: number) => {
                this.updatePlotSeries(scope, index);
            });
        }

        private updatePlotSeries(scope: IGridDigiconMonitorScope, index: number): void {
            if (scope.plotSeries[index] === undefined && scope.trendingInfos[index].plotSeries) {
                scope.plotSeries[index] = scope.trendingInfos[index].plotSeries[0];
                scope.plotSeries[index + 1] = scope.trendingInfos[index].plotSeries[1];
                scope.plotSeries[index + 2] = scope.trendingInfos[index].plotSeries[2];
                scope.plotSeries[index + 3] = scope.trendingInfos[index].plotSeries[3];
                scope.plotSeries[index + 4] = scope.trendingInfos[index].plotSeries[4];
                scope.plotSeries[index + 5] = scope.trendingInfos[index].plotSeries[5];

            }
            if (scope.trendingInfos[index].lastValidPoints) {
                scope.lastValidPoints[index] = scope.trendingInfos[index].lastValidPoints[0];
                scope.lastValidPoints[index + 1] = scope.trendingInfos[index].lastValidPoints[1];
                scope.lastValidPoints[index + 2] = scope.trendingInfos[index].lastValidPoints[2];
                scope.lastValidPoints[index + 3] = scope.trendingInfos[index].lastValidPoints[3];
                scope.lastValidPoints[index + 4] = scope.trendingInfos[index].lastValidPoints[4];
                scope.lastValidPoints[index + 5] = scope.trendingInfos[index].lastValidPoints[5];
            }
        }
    }
}
